/* Thin initializer wrapper for legacy newRebateSearch.js
 * Shopify section context.
 *
 * First iteration: assumes only ONE rebate finder instance per page because legacy code uses
 * global selectors like document.getElementsByClassName('utilities')[0].
 *
 * Later iteration: refactor legacy into instance-scoped widget.
 */

(function () {
  function safeInit() {
    if (!window.newRebateSearch || typeof window.newRebateSearch.producPageSetup !== 'function') {
      console.warn('[rebate-finder] newRebateSearch not found.');
      return;
    }

    // Stubs for functions referenced in some legacy branches
    window.openModal = window.openModal || function () { location.hash = '#rebate_popup1'; };
    window.observerMiniCart = window.observerMiniCart || function () {};
    window.closeAndRefreshCart = window.closeAndRefreshCart || function () { location.hash = ''; };
    window.tags = window.tags || '';

    // Section setting is not directly available in JS in a static asset.
    // For now, pass empty string; if you want category-specific logic, we can embed it inline in Liquid.
    window.newRebateSearch.producPageSetup('');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeInit);
  } else {
    safeInit();
  }
})();
